import produce from "immer";

const getDefaultState = () => {
  return [];
};

const roles = (state = getDefaultState(), action) => {
  let nextState;
  switch (action.type) {
    case "ROLES_GET":
      nextState = produce(state, (draftState) => action.payload.data);
      return nextState;
    default:
      return state;
  }
};

export default roles;
